import { PACKAGES } from "@/data/content";
import { PackageCard, PageHero } from "@/components/site/ui";

export default function Packages() {
  return (
    <div data-testid="packages-page">
      <PageHero eyebrow="All Packages" title="Bundles that grow" highlight="with you" text="Save more by learning skills together. Every package includes community access, live sessions and certificates." />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {PACKAGES.map((p, i) => <PackageCard key={p.slug} p={p} i={i} />)}
      </div>
    </div>
  );
}
